module.exports = __webpack_public_path__ + "static/media/building.e2d03e58.jpg";